<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>

    <div v-show="!loading" class="content">
      <div class="flash-message text-center" v-if="updateRequiredMessage">
        <div class="alert" :class="'alert-info'">
          {{ updateRequiredMessage }}
        </div>
      </div>

      <div class="box box-primary profile_wrapper">
        <div class="box-body">
          <ul class="nav nav-tabs" style="padding-left: 15px;">
            <!-- <li :class="pictureActive"><a data-toggle="tab" href="#picture">Picture</a></li> -->
            <li :class="detailsActive">
              <a data-toggle="tab" href="#details">Details</a>
            </li>
            <li :class="settingsActive">
              <a data-toggle="tab" href="#settings">Settings</a>
            </li>
          </ul>

          <div class="tab-content profile_wrapper_paddi">
            <!-- <div id="picture" class="tab-pane fade in" :class="pictureActive">
              <profile-image></profile-image>
            </div> -->
            <div id="details" class="tab-pane fade in" :class="detailsActive">
              <div class="col-md-12">
                <vue-form
                  :state="formstate"
                  @submit.prevent="onSubmit"
                  class="row"
                >
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <validate
                        auto-label
                        class="form-group required-field"
                        :class="fieldClassName(formstate.firstName)"
                      >
                        <label>First Name</label>
                        <input
                          maxlength="25"
                          class="form-control"
                          name="firstName"
                          required
                          placeholder="First Name"
                          type="text"
                          v-model="newProfile.firstName"
                          pattern="[a-zA-Z\sand mod]{0,25}"
                        />
                        <field-messages
                          name="firstName"
                          show="$touched || $submitted"
                          class="form-control-feedback"
                        >
                          <div slot="required">
                            This is a required field
                          </div>
                          <div slot="pattern">
                            Alphabets are allowed.
                          </div>
                        </field-messages>
                      </validate>
                    </div>
                    <div class="col-sm-6">
                      <validate
                        auto-label
                        class="form-group"
                        :class="fieldClassName(formstate.lastName)"
                      >
                        <label>Last Name</label>
                        <input
                          maxlength="25"
                          class="form-control"
                          name="lastName"
                   
                          placeholder="Last Name"
                          type="text"
                          v-model="newProfile.lastName"
                          pattern="[a-zA-Z\sand mod]{0,25}"
                        />
                        <field-messages
                          name="lastName"
                          show="$touched || $submitted"
                          class="form-control-feedback"
                        >
                          
                          <div slot="pattern">
                            Alphabets are allowed.
                          </div>
                        </field-messages>
                      </validate>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="col-sm-6">
                      <validate
                        auto-label
                        class="form-group required-field"
                        :class="fieldClassName(formstate.email)"
                        :custom="{ email: emailValidator }"
                      >
                        <label>Email </label>
                        <input
                          required
                          maxlength="50"
                          v-model="newProfile.email"
                          type="email"
                          class="form-control"
                          name="email"
                          placeholder="Email"
                        />
                        <field-messages
                          name="email"
                          show="$touched || $submitted"
                          class="form-control-feedback"
                        >
                          <div slot="required">This is required field</div>
                          <div slot="email">Email is invalid</div>
                        </field-messages>
                      </validate>
                    </div>
                  </div>

                  <!-- 
                  <validate auto-label class="form-group" :class="fieldClassName(formstate.title)">
                    <vue-form-input
                      v-model="newProfile.title"
                      :formstate="formstate"
                      :type="'text'"
                      :label="'Title:'"
                      :placeholder="'Ex: Central Marketing Developer'"
                      :name="'title'"
                      :messages="{}"
                    >
                    </vue-form-input>
                  </validate>

                  <validate
                    auto-label
                    class="form-group"
                    :class="fieldClassName(formstate.location)"
                  >
                    <vue-form-input
                      v-model="newProfile.location"
                      :formstate="formstate"
                      :type="'text'"
                      :label="'Location:'"
                      :placeholder="'City, State, Country'"
                      :name="'location'"
                      :messages="{}"
                    >
                    </vue-form-input>
                  </validate>

                  <validate
                    auto-label
                    class="form-group"
                    :class="fieldClassName(formstate.education)"
                  >
                    <vue-form-input
                      v-model="newProfile.education"
                      :formstate="formstate"
                      :type="'text'"
                      :label="'Education:'"
                      :placeholder="
                        'Ex: B.S. in Computer Science from the University of Tennessee at Knoxville'
                      "
                      :name="'education'"
                      :messages="{}"
                    >
                    </vue-form-input>
                  </validate>

                  <label>Bio:</label> 
                  <textarea v-model="newProfile.bio" class="form-control" style="height:200px;" placeholder="Ex: I'm an amazingly interesting person!"></textarea>
-->
                </vue-form>

                <div class="py-2 row" style="margin-top: 10px">
                  <div class="col-sm-12">
                    <button
                      class="btn colorbtn"
                      type="submit"
                      @click="updateProfile"
                      :disabled="!formstate.$dirty || formstate.$invalid"
                      v-if="$route.params && !$route.params._id"
                    >
                      Update Profile
                    </button>
                  </div>
                  <!-- <button class="btn btn-danger" @click="deleteUserModal">Delete Account</button> -->
                  <!-- <button class="btn btn-primary" type="submit" @click="clearChanges" :disabled="formstate.$pristine">Clear Changes</button> -->
                </div>

                <div
                  class="py-2 text-center row"
                  style="margin-top: 10px"
                ></div>
              </div>
            </div>
            <div id="settings" class="tab-pane fade in" :class="settingsActive">
              <!-- <div class="callout callout-info">
                <h4>Tip!</h4>

                <p>Your 4 digit PIN will be required if you need to reset your
                  password in the future. Please keep it somewhere safe.</p>
              </div> -->

              <div class="col-md-4 col-md-offset-4">
                <vue-form
                  :state="passwordFormstate"
                  @submit.prevent="updatePassword"
                  class="row"
                >
                  <div class="col-sm-12">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(passwordFormstate.newPassword)"
                    >
                      <label>New Password</label>
                      <input
                        class="form-control"
                        id="password"
                        maxlength="25"
                        name="newPassword"
                        required
                        placeholder="New Password"
                        type="password"
                        v-model="newPassword"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$#!%*?&]{8,}$"
                      />
                      <field-messages
                        name="newPassword"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          New Password is a required field
                        </div>
                        <div slot="pattern">
                          Password should have at least one uppercase letter,
                          one lowercase letter, one number and one special
                          character. ( eg: Xyz@1234 )
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-12">
                    <validate
                      auto-label
                      class="form-group required-field"
                      :class="fieldClassName(passwordFormstate.confirmPassword)"
                    >
                      <label>Confirm Password</label>
                      <input
                        maxlength="25"
                        class="form-control"
                        id="passwordVerify"
                        name="confirmPassword"
                        required
                        placeholder="Confirm Password"
                        type="password"
                        v-model="confirmPassword"
                        pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&])[A-Za-z\d@$!%#*?&]{8,}$"
                      />
                      <field-messages
                        name="confirmPassword"
                        show="$touched || $submitted"
                        class="form-control-feedback"
                      >
                        <div slot="required">
                          Confirm Password is a required field
                        </div>
                        <div slot="pattern">
                          Password should have at least one uppercase letter,
                          one lowercase letter, one number and one special
                          character. ( eg: Xyz@1234 )
                        </div>
                      </field-messages>
                    </validate>
                  </div>
                  <div class="col-sm-12">
                    <input type="checkbox" v-on:click="showPassword" /><span
                      >Show Password</span
                    >
                  </div>
                  <div class="form-actions">
                    <button
                      type="submit"
                      class="mr-2 btn gradientbt"
                      :disabled="
                        !(passwordFormstate.$dirty && passwordFormstate.$valid)
                      "
                      v-if="$route.params && !$route.params._id"
                    >
                      Update Password
                    </button>
                  </div>
                </vue-form>

                <!-- <vue-form :state="pinFormstate" @submit.prevent="updatePIN" class="row">

                  <validate auto-label class="form-group" :class="fieldClassName(pinFormstate.pin)" :custom="{ minlength: minlengthValidator(4) }">
                    <vue-form-input
                      required
                      v-model="pin"
                      :pinFormstate="pinFormstate"
                      :type="'text'"
                      :label="'PIN:'"
                      :name="'pin'"
                      :mask="'1111'"
                      :minlength="'4'"
                      :placeholder="'Please enter your 4 digit PIN.'"
                      :messages="{ required: 'This field is required', minlength: 'PIN must be 4 digits.' }">
                    </vue-form-input>
                  </validate>

                  <div class="content-centered">
                    <button type="submit" class="btn btn-primary btn-lg" style="margin-top: 15px;"
                            :disabled="pinFormstate.$dirty || pinFormstate.$invalid || passwordScoreUpdating">Update PIN</button>

                  </div>
                </vue-form> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProfileImage from "./ProfileImage.vue";
import {
  userService,
  authService,
  formService,
  eventBus,
} from "../../../services";
import { EVENTS } from "../../../config";
import swal from "sweetalert2";

import _ from "lodash";

export default {
  name: "Profile",
  components: {
    ProfileImage,
  },
  data() {
    return {
      ready: false,
      loading: false,
      detailsActive: "",
      pictureActive: "",
      settingsActive: "",
      updateRequiredMessage: "",
      newProfile: {},
      oldProfile: {},
      passwordFormstate: {},
      formstate: {},
      pinFormstate: {},
      newPassword: "",
      confirmPassword: "",
      pin: null,
      passwordScore: 0,
      passwordScoreUpdating: false,
      details: {},
    };
  },
  methods: {
    fieldClassName: formService.fieldClassName,
    emailValidator: formService.emailValidator,
    emailUniqueValidator(email) {
      return formService.emailUniqueValidator(email, this.oldProfile.email);
    },
    minlengthValidator(minlength) {
      // the masked input comes with '_' chars, so we need to remove those before checking the length
      return (input) => {
        return formService.minlengthValidator(input.split("_")[0], minlength);
      };
    },
    passwordScoreValidator() {
      return formService.passwordScoreValidator(this.passwordScore);
    },
    passwordConfirmValidator(confirmPassword) {
      return formService.passwordConfirmValidator(
        this.newPassword,
        confirmPassword
      );
    },
    validateConfirm() {
      this.passwordFormstate.confirmPassword._validate();
    },
    clearChanges() {
      this.newProfile = _.cloneDeep(this.oldProfile);
      this.formstate._reset();
    },
    updateProfile() {
      this.loading = true;
      const {
        _id,
        email,
        cityId,
        firstName,
        lastName,
        pin,
        createdBy,
        deletedBy,
        isActive,
        isRootUser,
        updatedBy,
        userId,
      } = this.$store.state.auth.user;
      this.newProfile._id = this.$store.state.auth.user._id;
      this.newProfile.role = this.$store.state.auth.user.role;

      if (this.$store.state.auth.user.isRootUser == true) {
        let payload = {
          user: {
            // _id: this.newProfile._id,
            email: this.newProfile.email,
            firstName: this.newProfile.firstName,
            lastName: this.newProfile.lastName,
            createdBy,
            deletedBy,
            isActive,
            isRootUser,
            pin,
            role: this.newProfile.role,
            updatedBy,
            userId,
            // cityId,
            _id,
            // email,
            // firstName,
            // lastName
          },
          registerType: "Invite",
        };
        console.log("payload", payload);
        return userService
          .updateUserProfile(payload)
          .then((response) => {
            this.loading = false;
            this.formstate._reset();
            this.oldProfile = _.cloneDeep(this.newProfile);
            // Update the global user object
            const user = Object.assign(
              this.$store.state.auth.user,
              this.newProfile
            );
            // user.profileImageUrl = this.profileImageUrl
            this.$store.commit("auth/SET_USER", user);
            this.$snotify.success("Profile updated", "Success!");
          })
          .catch((error) => {
            this.loading = false;
            this.$snotify.error("Update profile failed", "Error!");
          });
      } else {
        let payload = {
          user: {
            email: this.newProfile.email,
            firstName: this.newProfile.firstName,
            lastName: this.newProfile.lastName,
            createdBy,
            deletedBy,
            isActive,
            isRootUser,
            pin,
            role: this.newProfile.role,
            updatedBy,
            userId,
            cityId: this.$store.state.auth.user.cityId._id,
            _id,
            // email,
            // firstName,
            // lastName
          },
          registerType: "Invite",
        };
        console.log("payload", payload);
        return userService
          .updateUserProfile(payload)
          .then((response) => {
            this.loading = false;
            this.formstate._reset();
            this.oldProfile = _.cloneDeep(this.newProfile);
            // Update the global user object
            const user = Object.assign(
              this.$store.state.auth.user,
              this.newProfile
            );
            // user.profileImageUrl = this.profileImageUrl
            this.$store.commit("auth/SET_USER", user);
            this.$snotify.success("Profile updated", "Success!");
          })
          .catch((error) => {
            this.loading = false;
            this.$snotify.error("Update profile failed", "Error!");
          });
      }
      // const payloadUpdate = this.$store.state.auth.user.cityId != null ? payloadCityId : payload;
      // console.log('updatepayload',payloadUpdate)
      // return userService
      //     .updateUserProfile(payload)
      //     .then((response) => {
      //         this.loading = false;
      //         this.formstate._reset();
      //         this.oldProfile = _.cloneDeep(this.newProfile);
      //         // Update the global user object
      //         const user = Object.assign(
      //             this.$store.state.auth.user,
      //             this.newProfile
      //         );
      //         // user.profileImageUrl = this.profileImageUrl
      //         this.$store.commit("auth/SET_USER", user);
      //         this.$snotify.success("Profile updated", "Success!");
      //     })
      //     .catch((error) => {
      //         this.loading = false;
      //         this.$snotify.error("Update profile failed", "Error!");
      //     });
    },

    showPassword() {
      let x = document.getElementById("password");
      let y = document.getElementById("passwordVerify");
      if (x.type === "password" && y.type === "password") {
        x.type = "text";
        y.type = "text";
      } else {
        x.type = "password";
        y.type = "password";
      }
    },

    updatePassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.loading = false;
        this.$snotify.error(`New Password and Confirm Password must be Same`);
        return;
      }
      this.loading = true;
      this.details["email"] = this.$store.state.auth.user.email;
      this.details["password"] = this.newPassword;
      this.details["confirmPassword"] = this.confirmPassword;
      authService
        .updateUserPassword(this.details)
        .then((response) => {
          this.loading = false;
          const user = Object.assign(this.$store.state.auth.user, {
            passwordUpdateRequired: false,
          });
          this.$store.commit("auth/SET_USER", user);
          this.logout();
        })
        .catch((error) => {
          this.loading = false;
          if (error.data && error.data.message) {
            this.$snotify.error(error.data.message, "Error!");
          } else {
            this.$snotify.error("Update password failed", "Error!");
          }
        });
    },
    logout() {
      this.$snotify.success("Password Updated, Kindly Login again", "Success!");
      this.loading = true;
      localStorage.clear();
      sessionStorage.clear();
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var spcook = cookies[i].split("=");
        document.cookie =
          spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
      }
      setTimeout(() => {
        window.location.href = "/login";
      }, 500);
    },
    updatePIN() {
      this.loading = true;
      userService
        .updateUserPIN(this.pin)
        .then((response) => {
          this.loading = false;
          this.pinFormstate._reset();
          // Update the global user object
          const user = Object.assign(this.$store.state.auth.user, {
            pinUpdateRequired: false,
          });
          this.$store.commit("auth/SET_USER", user);
          this.$snotify.success("PIN updated", "Success!");
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Update pin failed", "Error!");
        });
    },
    deleteUserModal() {
      swal({
        title: "Are you sure?",
        text: "This will permanently delete your account!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          this.deleteUser();
        }
      });
    },
    deleteUser() {
      this.loading = true;
      return userService
        .deleteCurrentAccount(this.newProfile._id)
        .then((response) => {
          this.loading = false;
          return swal("Deleted!", "Your account has been deleted.", "success");
        })
        .then((result) => {
          authService.logout();
          this.$router.push("/login");
        })
        .catch((error) => {
          this.loading = false;
          this.$snotify.error("Delete account failed", "Error!");
        });
    },
  },
  // updatePassword() {
  //   this.loading = true;
  //   this.details = {};
  //   this.details["email"] = this.$store.state.auth.user.email;
  //   this.details["password"] = this.newPassword;
  //   this.details["confirmPassword"] = this.confirmPassword;

  //   authService
  //     .updateUserPassword(this.details)
  //     .then((response) => {
  //       this.details = {};
  //       this.loading = false;
  //       this.$snotify.success("Password updated", "Success!");
  //     })
  //     .catch((error) => {
  //       this.loading = false;
  //       console.error("UserProfile.updatePassword-error:", error);
  //       this.$snotify.error("Update password failed", "Error!");
  //     });
  // },
  updatePIN() {
    this.loading = true;
    userService
      .updateUserPIN(this.pin)
      .then((response) => {
        this.loading = false;
        this.pinFormstate._reset();
        // Update the global user object
        const user = Object.assign(this.$store.state.auth.user, {
          pinUpdateRequired: false,
        });
        this.$store.commit("auth/SET_USER", user);
        this.$snotify.success("PIN updated", "Success!");
      })
      .catch((error) => {
        this.loading = false;
        console.error("UserProfile.updatePIN-error:", error);
        this.$snotify.error("Update pin failed", "Error!");
      });
  },
  deleteUserModal() {
    swal({
      title: "Are you sure?",
      text: "This will permanently delete your account!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        this.deleteUser();
      }
    });
  },
  deleteUser() {
    this.loading = true;
    return userService
      .deleteCurrentAccount(this.newProfile._id)
      .then((response) => {
        this.loading = false;
        return swal("Deleted!", "Your account has been deleted.", "success");
      })
      .then((result) => {
        authService.logout();
        this.$router.push("/login");
      })
      .catch((error) => {
        this.loading = false;
        console.error("UserProfile.deleteUser-error:", error);
        this.$snotify.error("Delete account failed", "Error!");
      });
  },
  created() {
    // Filter out unneeded user properties for the profile
    this.newProfile = (({
      email,
      firstName,
      lastName,
      title,
      education,
      location,
      bio,
    }) => {
      return {
        email,
        firstName,
        lastName,
        title,
        education,
        location,
        bio,
      };
    })(this.$store.state.auth.user);

    this.oldProfile = _.cloneDeep(this.newProfile);

    // Set the active tab
    if (this.$route.query.settings) {
      this.settingsActive = "active";
    } else {
      this.detailsActive = "active";
    }
    // else {
    //   this.pictureActive = 'active'
    // }
    // Notify the user of any required updates
    if (
      this.$store.state.auth.user.passwordUpdateRequired &&
      this.$store.state.auth.user.pinUpdateRequired
    ) {
      this.updateRequiredMessage =
        "You must update your password and PIN to continue.";
    } else if (this.$store.state.auth.user.passwordUpdateRequired) {
      this.updateRequiredMessage = "You must update your password to continue.";
    } else if (this.$store.state.auth.user.pinUpdateRequired) {
      this.updateRequiredMessage = "You must update your PIN to continue.";
    }

    eventBus.$on(EVENTS.PASSWORD_SCORE_UPDATED, (passwordScore) => {
      this.passwordScoreUpdating = false;
      this.passwordScore = passwordScore;
    });
    eventBus.$on(EVENTS.UPDATING_PASSWORD_SCORE, () => {
      this.passwordScoreUpdating = true;
    });
  },
};
</script>
<style>
.form-control-feedback{
  color: red !important;
  font-weight: 100;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

</style>



// WEBPACK FOOTER //
// Profile.vue?22c223f2